import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=c34b067e&"
import script from "./CreateQuestion.vue?vue&type=script&lang=ts&"
export * from "./CreateQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./CreateQuestion.vue?vue&type=style&index=0&id=c34b067e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports